export default {
  props: {
    properties: {
      type: Object,
      default: function () {
        return {};
      }
    },
    childList: {
      type: Array,
      default: function () {
        return [];
      }
    },
  },
}      